export default "/images/OBROncology.png?3930d59407d2441e28f4170a807b5348";